module.exports = __webpack_public_path__ + "img/serve.2b5cb9b3.png";